<template>
  <b-card
    class="profile-header mb-2"
    :img-src="require('@/assets/images/banner/banner-2.jpg')"
    img-top
    alt="cover photo"
    body-class="p-0"
  >
    <!-- profile picture -->
    <div class="position-relative">
      <div class="profile-img-container d-flex align-items-center">
        <div class="profile-img">
          <b-img
            :src="serverUrl+eduProgram.icon_path"
            rounded
            fluid
            alt="profile photo"
           
          />
        </div>
        <!-- profile title -->
        <div class="profile-title ml-3">
          <h2 class="text-white">
            {{ eduProgram.name }}
          </h2>
          <p class="text-white" v-html="eduProgram.explanation">
           </p>
        </div>
        <!--/ profile title -->
      </div>
    </div>
    <!--/ profile picture -->

    <!--/ profile navbar -->
  </b-card>
</template>

<script>
import {
  BCard,
  BImg,
  BNavbar,
  BNavbarToggle,
  BCollapse,
  BTabs,
  BNavItem,
  BButton

} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Auth from "@/Apis/Auth";
import config from '@/config/config';

export default {
  components: {
    BCard,
    BTabs,
    BButton,
    BNavItem,
    BNavbar,
    BNavbarToggle,
    BCollapse,
    BImg,
  },
  directives: {
    Ripple,
  },
  props:{
 eduProgram: {}, 

 },
  data(){
    return{
      serverUrl:config.serverUrl

    }
  },
  created() {
    // let id = localStorage.getItem("eduProgram");
    // this.eduProgram = Auth.EDU_PROGRAMS.find((a) => a.id == id);
    // console.log(this.eduProgram);
  },
};
</script>

<style scoped>
.profile-header > img {
  min-height: 160px
}

@media screen and (max-width: 768px) {
  
  #user-profile .profile-header .profile-img-container {
bottom: 0;
} 
}
</style>